const BaseURL = "https://pasigo.onrender.com/api/";
//const  BaseURL = "http://localhost:5007/api/";
export default BaseURL;